import { render } from "./SortByButton.vue?vue&type=template&id=20a474fe"
import script from "./SortByButton.vue?vue&type=script&lang=js"
export * from "./SortByButton.vue?vue&type=script&lang=js"

import "./SortByButton.vue?vue&type=style&index=0&id=20a474fe&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__